import { Chat, SessionPhoto } from "../Shared/GeneratedTypes";
// import { LiveSwitchApp } from "./LiveSwitchApp";
import { InputInfo } from "../Shared/sharedTypes";
import * as types from "./liveSwitchActionTypes";

export function sendChat(chat: Chat) {
    return {
        type: types.SEND_CHAT as typeof types.SEND_CHAT,
        chat,
    };
}

export function takePhoto(photoId: string) {
    return {
        type: types.TAKE_LOCAL_MEDIA_PHOTO as typeof types.TAKE_LOCAL_MEDIA_PHOTO,
        photoId,
    };
}

export function chatReceived(chat: Chat, localizedNotificationMessage: string) {
    return {
        type: types.RECEIVE_CHAT as typeof types.RECEIVE_CHAT,
        chat,
        localizedNotificationMessage,
    };
}

export function remoteVideoDeviceListReceived(videoDevices: InputInfo[]) {
    return {
        type: types.REMOTE_VIDEO_DEVICE_LIST_RECEIVED as typeof types.REMOTE_VIDEO_DEVICE_LIST_RECEIVED,
        videoDevices,
    };
}

export function localVideoDeviceListReceived(videoDevices: InputInfo[]) {
    return {
        type: types.LOCAL_VIDEO_DEVICE_LIST_RECEIVED as typeof types.LOCAL_VIDEO_DEVICE_LIST_RECEIVED,
        videoDevices,
    };
}
export function imageStillForAIReceived(image: Blob, dateTaken: Date, wasPreviouslyQueued: boolean) {
    return {
        type: types.IMAGE_STILL_FOR_AI_RECEIVED as typeof types.IMAGE_STILL_FOR_AI_RECEIVED,
        image,
        dateTaken,
        wasPreviouslyQueued,
    };
}

export function connectionQualityPing(connectionValue: number, deviceId: string) {
    return {
        type: types.CONNECTION_QUALITY_PING as typeof types.CONNECTION_QUALITY_PING,
        connectionValue,
        deviceId,
    };
}

export function connectionQualityBelowThreshold() {
    return {
        type: types.CONNECTION_QUALITY_BELOW_THRESHOLD as typeof types.CONNECTION_QUALITY_BELOW_THRESHOLD,
    };
}

export function issueClientConnectionQualityWarning() {
    return {
        type: types.ISSUE_CLIENT_CONNECTION_QUALITY_WARNING as typeof types.ISSUE_CLIENT_CONNECTION_QUALITY_WARNING,
    };
}

export function cancelClientConnectionQualityWarning() {
    return {
        type: types.CANCEL_CLIENT_CONNECTION_QUALITY_WARNING as typeof types.CANCEL_CLIENT_CONNECTION_QUALITY_WARNING,
    };
}

export function localAudioInputListReceived(audioInputs: InputInfo[]) {
    return {
        type: types.LOCAL_AUDIO_INPUT_LIST_RECEIVED as typeof types.LOCAL_AUDIO_INPUT_LIST_RECEIVED,
        audioInputs,
    };
}

export function localAudioOutputListReceived(audioOutputs: InputInfo[]) {
    return {
        type: types.LOCAL_AUDIO_OUTPUT_LIST_RECEIVED as typeof types.LOCAL_AUDIO_OUTPUT_LIST_RECEIVED,
        audioOutputs,
    };
}

export function photoTaken(id: string, photoData: Blob) {
    return {
        type: types.PHOTO_DATA_RECEIVED as typeof types.PHOTO_DATA_RECEIVED,
        photoData,
        id,
    };
}

export function photoRequestReceived(photoId: string, localizedNotificationMessage: string) {
    return {
        type: types.PHOTO_REQUEST_RECEIVED as typeof types.PHOTO_REQUEST_RECEIVED,
        photoId,
        localizedNotificationMessage,
    };
}

export function receivedPhotoUrl(id: string, url: string, sessionId: string, thumbnailUrl: string) {
    return {
        type: types.PHOTO_URL_RECEIVED as typeof types.PHOTO_URL_RECEIVED,
        id,
        url,
        thumbnailUrl,
        sessionId,
    };
}
export function receivedVideoFrameTagPhotoUrl(orderId: string, photo: SessionPhoto) {
    return {
        type: types.VIDEO_FRAME_TAG_PHOTO_URL_RECEIVED as typeof types.VIDEO_FRAME_TAG_PHOTO_URL_RECEIVED,
        orderId,
        photo,
    };
}
export function sessionEnded(orderId: string) {
    return {
        type: types.SESSION_ENDED_RECEIVED as typeof types.SESSION_ENDED_RECEIVED,
        orderId,
    };
}
export function photoUrlCommand(id: string, url: string, thumbnailUrl: string) {
    return {
        type: types.COMMAND_SEND_PHOTO_URL as typeof types.COMMAND_SEND_PHOTO_URL,
        url,
        thumbnailUrl,
        id,
    };
}

export function videoFrameTagPhotoUrlCommand(orderId: string, photo: SessionPhoto) {
    return {
        type: types.COMMAND_SEND_VIDEO_FRAME_TAG_PHOTO_URL as typeof types.COMMAND_SEND_VIDEO_FRAME_TAG_PHOTO_URL,
        orderId,
        photo,
    };
}

export function sendPhotoDeletedCommand(photoId: string) {
    return {
        type: types.COMMAND_SEND_PHOTO_REMOVED as typeof types.COMMAND_SEND_PHOTO_REMOVED,
        photoId,
    };
}

export function networkStatusUpdated(id: string, connected: boolean) {
    return {
        type: types.NETWORK_STATUS_UPDATED as typeof types.NETWORK_STATUS_UPDATED,
        connected,
        id,
    };
}
export function toggleRemoteCameraMute() {
    return {
        type: types.COMMAND_MUTE_REMOTE_CAMERA as typeof types.COMMAND_MUTE_REMOTE_CAMERA,
    };
}
export function sendSessionEnded() {
    return {
        type: types.COMMAND_SESSION_ENDED as typeof types.COMMAND_SESSION_ENDED,
    };
}

export function toggleRemoteAudioMute() {
    return {
        type: types.COMMAND_MUTE_REMOTE_AUDIO as typeof types.COMMAND_MUTE_REMOTE_AUDIO,
    };
}

export function sendClientAudioMuteUpdated(muted: boolean) {
    return {
        type: types.CLIENT_AUDIO_MUTE_UPDATED as typeof types.CLIENT_AUDIO_MUTE_UPDATED,
        muted,
    };
}

export function toggleLocalVideo() {
    return {
        type: types.TOGGLE_LOCAL_VIDEO as typeof types.TOGGLE_LOCAL_VIDEO,
    };
}

export function toggleLocalAudio() {
    return {
        type: types.TOGGLE_LOCAL_AUDIO as typeof types.TOGGLE_LOCAL_AUDIO,
    };
}

/**
 *
 * @param quality a number 1-5 1 is low and 5 is high quality
 */
export function setCanvasReducerQuality(quality: number) {
    return {
        type: types.SET_CANVAS_REDUCER_QUALITY as typeof types.SET_CANVAS_REDUCER_QUALITY,
        quality,
    };
}
export function sendCanvasQualityCommand(quality: number) {
    return {
        type: types.SEND_CANVAS_QUALITY_COMMAND as typeof types.SEND_CANVAS_QUALITY_COMMAND,
        quality,
    };
}
export function requestPhotoCommand(id: string) {
    return {
        type: types.COMMAND_REQUEST_PHOTO as typeof types.COMMAND_REQUEST_PHOTO,
        id,
    };
}

export function changeLocalActiveCamera(id: string, name: string) {
    return {
        type: types.SET_LOCAL_VIDEO_INPUT as typeof types.SET_LOCAL_VIDEO_INPUT,
        id,
        name,
    };
}

export function changeLocalAudioInput(id: string, name: string) {
    return {
        type: types.SET_LOCAL_AUDIO_INPUT as typeof types.SET_LOCAL_AUDIO_INPUT,
        id,
        name,
    };
}

export function changeLocalAudioOutput(id: string, name: string) {
    return {
        type: types.SET_LOCAL_AUDIO_OUTPUT as typeof types.SET_LOCAL_AUDIO_OUTPUT,
        id,
        name,
    };
}

export function changeCameraCommand(id: string, name: string) {
    return {
        type: types.COMMAND_CHANGE_REMOTE_CAMERA as typeof types.COMMAND_CHANGE_REMOTE_CAMERA,
        id,
        name,
    };
}

export function changeRecordingStatus(isRecording: boolean) {
    return {
        type: types.COMMAND_TOGGLE_RECORDING as typeof types.COMMAND_TOGGLE_RECORDING,
        isRecording,
    };
}

export function setOtherPartyActive(active: boolean) {
    return {
        type: types.SET_GUEST_ACTIVE_STATE as typeof types.SET_GUEST_ACTIVE_STATE,
        active,
    };
}

export function toggleCameraBusy(busy: boolean) {
    return {
        type: types.SET_CAMERA_BUSY_STATUS as typeof types.SET_CAMERA_BUSY_STATUS,
        busy,
    };
}

export function setAudioMuteConfirmState(confirmationNeeded: boolean) {
    return {
        type: types.AUDIO_MUTE_CONFIRMATION_STATE_UPDATED as typeof types.AUDIO_MUTE_CONFIRMATION_STATE_UPDATED,
        confirmationNeeded,
    };
}
export function setVideoMuteConfirmState(confirmationNeeded: boolean) {
    return {
        type: types.VIDEO_MUTE_CONFIRMATION_STATE_UPDATED as typeof types.VIDEO_MUTE_CONFIRMATION_STATE_UPDATED,
        confirmationNeeded,
    };
}

export function setChangeCameraConfirmState(deviceId: string | null) {
    return {
        type: types.CHANGE_CAMERA_CONFIRMATION_UPDATED as typeof types.CHANGE_CAMERA_CONFIRMATION_UPDATED,
        deviceId,
    };
}

export function photoRemoved(photoId: string) {
    return {
        type: types.PHOTO_REMOVED as typeof types.PHOTO_REMOVED,
        photoId,
    };
}

export function recordingToggled(isRecording: boolean) {
    return {
        type: types.RECORDING_TOGGLED as typeof types.RECORDING_TOGGLED,
        isRecording,
    };
}

export function getAudioOutputDevices() {
    return {
        type: types.GET_AUDIO_OUTPUT_DEVICES as typeof types.GET_AUDIO_OUTPUT_DEVICES,
    };
}

export type LiveSwitchAction =
    | ReturnType<typeof setAudioMuteConfirmState>
    | ReturnType<typeof imageStillForAIReceived>
    | ReturnType<typeof setVideoMuteConfirmState>
    | ReturnType<typeof setChangeCameraConfirmState>
    | ReturnType<typeof chatReceived>
    | ReturnType<typeof sendChat>
    | ReturnType<typeof photoRemoved>
    | ReturnType<typeof remoteVideoDeviceListReceived>
    | ReturnType<typeof localAudioInputListReceived>
    | ReturnType<typeof localVideoDeviceListReceived>
    | ReturnType<typeof localAudioOutputListReceived>
    | ReturnType<typeof photoTaken>
    | ReturnType<typeof receivedPhotoUrl>
    | ReturnType<typeof sessionEnded>
    | ReturnType<typeof photoUrlCommand>
    | ReturnType<typeof takePhoto>
    | ReturnType<typeof requestPhotoCommand>
    | ReturnType<typeof toggleLocalVideo>
    | ReturnType<typeof changeCameraCommand>
    | ReturnType<typeof toggleLocalAudio>
    | ReturnType<typeof photoRequestReceived>
    | ReturnType<typeof setOtherPartyActive>
    | ReturnType<typeof toggleRemoteCameraMute>
    | ReturnType<typeof toggleCameraBusy>
    | ReturnType<typeof sendSessionEnded>
    | ReturnType<typeof changeLocalActiveCamera>
    | ReturnType<typeof toggleRemoteAudioMute>
    | ReturnType<typeof sendClientAudioMuteUpdated>
    | ReturnType<typeof sendPhotoDeletedCommand>
    | ReturnType<typeof changeLocalAudioOutput>
    | ReturnType<typeof networkStatusUpdated>
    | ReturnType<typeof setCanvasReducerQuality>
    | ReturnType<typeof sendCanvasQualityCommand>
    | ReturnType<typeof changeLocalAudioInput>
    | ReturnType<typeof recordingToggled>
    | ReturnType<typeof changeRecordingStatus>
    | ReturnType<typeof videoFrameTagPhotoUrlCommand>
    | ReturnType<typeof receivedVideoFrameTagPhotoUrl>
    | ReturnType<typeof issueClientConnectionQualityWarning>
    | ReturnType<typeof cancelClientConnectionQualityWarning>
    | ReturnType<typeof getAudioOutputDevices>;
